import styled from 'styled-components'

export const IconWrapper = styled.span`
  position: absolute;
  top: 11px;
  right: 0;
`

export const Wrapper = styled.div`
  width: 100%;
`

export const InputWrapper = styled.div`
  position: relative;
`

export const CalendarWrapper = styled.div`
  .rc-calendar-input-wrap {
    padding: 4px 6px 4px 6px;
  }

  .rc-calendar {
    margin-top: 18px;
  }

  .rc-calendar {
    width: 300px;
  }
`
